/* eslint-disable import/prefer-default-export */
import { apiCaller } from 'util/apiCaller';

const getMeInfo = function* getMeInfo() {
  const configAPI = {
    url: 'api/user/me',
    method: 'GET',
    isShowMessage: false
  };
  const data = apiCaller(configAPI);
  return yield data || [];
};

const getListVaiTro = function* getListVaiTro() {
  const configAPI = {
    url: 'api/vaitros',
    method: 'GET',
    params: {
      page: -1
    },
    isShowMessage: false
  };
  const data = apiCaller(configAPI);
  return yield data || [];
};

export const getInfo = {
  getMeInfo,
  getListVaiTro
};
